
import { Component, Vue } from 'vue-property-decorator';

// JP: All lang="ts" scripts must define components even if empty.
// If you delete these lines you will get the error (At "vue": "^2.6.10" and "vuetify": "^2.2.1"):
// TypeError: Cannot set property 'components' of undefined
//    at installComponents (installComponents.js:11)
@Component({
  metaInfo: {
    title: 'Log in to access & create 3D presentations & more',
    meta: [
      {
        name: 'description',
        content: `Log in to manage your team users, 3D assets, branding, and sharing settings.`,
      },
    ],
  },
  components: { },
})

export default class PreLogin extends Vue {
}
